<!-- 打板资金 -->
<template>
  <div class="dbcapital-wrap">
    <div style="display:flex;align-items: center;">
      <H3Title :title="'打板资金'"></H3Title>
      <div :ltip="szmessage" class="tips"></div>
    </div>

    <div class="chart-1">
      <ChartTpl
        :enableResize='true'
        :elementId='"dbcapitalCircle"'
        :width='"100%"'
        :height='"120px"'
        :option='circleOption'
        :originData='circleData'
      ></ChartTpl>
    </div>
    <div class="chart debug">
      <ChartTpl
        :elementId='"dbStack1"'
        :firstTooltip='true'
        :enableResize='true'
        :width='"100%"'
        :height='"248px"'
        :option='line1Option'
        :originData='line1Data'
      ></ChartTpl>
    </div>
  </div>
</template>

<script>
import H3Title from "@/components/H3Title";
import ChartTpl from '@/components/ChartTpl.vue';

export default {
  name: "DBCapital",
  components: {
    H3Title,
    ChartTpl
  },
  props: {
    elementId: {
      type: String,
      default: "hello"
    },
    catchMoney:{
      type: Object,
      default: function() {
        return {}
      }
    },
    catchMoneySeries: {
      type: Array,
      default: function(){
        return []
      }
    }
  },
  data() {
    return {
      chart: {},
      szmessage: '打板资金：涨停和曾涨停个股的成交额',
      circleOption: {},
      circleData:[],
      line1Option: {},
      line1Data:[]
    };
  },
  watch: {
    catchMoneySeries: {
      handler(newvalue, oldvalue){
        this.init();
      }
    }
  },
  mounted() {
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.catchMoneySeries.length) return;
    this.init();
  },
  methods:{
    initCircle(){
      let {catchSuccessfulMoney, catchFailMoney } = this.catchMoney;
      this.circleOption = this.$chartConfigs.doubleCircle();
      this.circleOption.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: '封板失败资金',
          values: [
            {
              value: catchFailMoney.percentile,
              show: catchFailMoney.value 
            }
          ]
        },{
          min: 0,
          max: 1,
          title: '封板成功资金',
          values: [
            {
              value: catchSuccessfulMoney.percentile,
              show: catchSuccessfulMoney.value 
            }
          ]
        }]
      };

      this.circleData = this.circleOption.data;
    },
    initStackBar(){
      this.line1Option = this.$chartConfigs.stackBar();
      this.line1Data = [{
          originData: this.catchMoneySeries.slice(-20)
        }]
    },
    init(){
      this.initStackBar();
      this.initCircle();
    }
  }
};
</script>

<style scoped>

.dbcapital-wrap {
  display: flex;
  flex-direction: column;
}
.chart-1 {
  margin-top: 15px;
  height: 120px;
  flex: 0 0 auto;
  margin-bottom: 1px;
}

.chart {
  flex: 1 1 auto;
}
.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:24px;
  height: 16px;
}
</style>
